import axios from 'axios';
import { ISecurityProfileProps } from '../../components/services/GraphQLSecurity';
import { IUserInfoProps } from '../../components/services/GraphQLShared';
import { API_ENDPOINTS } from '../../config/Config';

export const actions = {
  RESET_SECURITY_PROFILE: 'RESET_SECURITY_PROFILE',
  SET_USER_INFO: 'SET_USER_INFO',
  GET_SECURITY_PROFILE_PENDING: 'GET_SECURITY_PROFILE_PENDING',
  GET_SECURITY_PROFILE_RESOLVED: 'GET_SECURITY_PROFILE_RESOLVED',
  GET_SECURITY_PROFILE_REJECTED: 'GET_SECURITY_PROFILE_REJECTED',
} as const;

export const resetSecurityProfile = () => ({ type: actions.RESET_SECURITY_PROFILE });

export const getSecurityProfile = () => async (dispatch: any) => {
  dispatch({ type: actions.GET_SECURITY_PROFILE_PENDING });
  try {
    // Always hits the server: this thunk is also re-dispatched after a MAM sync clears the
    // server-side profile cache, so a stale client-cached copy would be wrong here.
    const { data } = await axios.get<ISecurityProfileProps>(API_ENDPOINTS.GET_SECURITY_PROFILE);
    dispatch({ type: actions.GET_SECURITY_PROFILE_RESOLVED, profile: data });
  } catch (error) {
    dispatch({ type: actions.GET_SECURITY_PROFILE_REJECTED, error });
  }
};
export type SecurityActionTypes = SetUserInfoAction;

interface SetUserInfoAction {
  type: typeof actions.SET_USER_INFO;
  value: IUserInfoProps;
}
export function setUserInfo(value: IUserInfoProps): SecurityActionTypes {
  return { type: actions.SET_USER_INFO, value: value };
}
